import "./TempleData.css";

export default function TempleData() {
  return (
    <>
      <div class="TempleData-landing-page">
        <div class="TempleData-overlay">
          <div class="TempleData-container">
            <div class="TempleData-text-intro">
              <h2>Welcome to Acme Web Solution</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                porta cursus urna nec rutrum. Fusce faucibus est eu ullamcorper
                ornare.
              </p>
              <button>Read More</button>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- End Landing Page -->

<!-- Start Web & Application --> */}

      <div class="TempleData-development">
        <div class="TempleData-container">
          <h2>Web & Application Development</h2>
          <p>
            Integer tristique mi in augue tincidunt, sit amet efficitur justo
            semper. Curabitur porttitor, tellus nec aliquam imperdiet, justo
            justo rhoncus dolor, tincidunt semper ipsum urna eget turpis. Sed
            maximus dui a nisl dignissim faucibus sed at eros. Donec a nulla
            vitae sem rutrum mollis ac eget lectus. Curabitur sed nulla sed.
          </p>
        </div>
      </div>

      {/* <!-- End Web & Application -->

<!--Start Boxes Fields --> */}

      <div class="TempleData-fields">
        <div class="TempleData-container">
          <div class="TempleData-boxes">
            <div class="TempleData-box">
              <img
                src="https://i.postimg.cc/K4X04zcL/clement-helardot-95YRwf6CNw8-unsplash.jpg"
                alt=""
              />
              <h3>Web Development</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                porta cursus urna nec rutrum. Fusce faucibus est eu ullamcorper
                ornare. Morbi velit erat, tincidunt ac tincidunt ut,
              </p>
            </div>
            <div class="TempleData-box">
              <img
                src="https://i.postimg.cc/C55THg5v/pexels-photo-261628.jpg"
                alt=""
              />
              <h3>Mobile Application</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                porta cursus urna nec rutrum. Fusce faucibus est eu ullamcorper
                ornare. Morbi velit erat, tincidunt ac tincidunt ut,
              </p>
            </div>
            <div class="TempleData-box">
              <img
                src="https://i.postimg.cc/tT3rwmZh/pexels-photo-265087.jpg"
                alt=""
              />
              <h3>Tech Marketing</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                porta cursus urna nec rutrum. Fusce faucibus est eu ullamcorper
                ornare. Morbi velit erat, tincidunt ac tincidunt ut,
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <!--End Boxes Fields -->

<!-- Start Handle --> */}

      <div class="TempleData-handle">
        <div class="TempleData-container">
          <h2>We handle all of your digital needs</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam porta
            cursus urna nec rutrum. Fusce faucibus est eu ullamcorper ornare.
            Morbi velit erat
          </p>
        </div>
      </div>
      {/* 
<!-- End Handle -->

<!-- Start Contact Us --> */}

      <div class="TempleData-info">
        <div class="TempleData-contact">
          <h3>Contact Us</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam porta
            cursus urna nec rutrum. Fusce faucibus est eu ullamcorper ornare.
            Morbi velit erat
          </p>
          <span>contact@acmewebsolutions.test</span>
        </div>
        <div class="TempleData-about">
          <h3>About Our Company</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam porta
            cursus urna nec rutrum. Fusce faucibus est eu ullamcorper ornare.
            Morbi velit erat Nullam nisl libero, eleifend et placerat id,
            dapibus sed ipsum.
          </p>
        </div>
      </div>

      {/* <!-- End Contact Us -->

<!-- Start Footer --> */}

      <div class="TempleData-footer">
        <div class="TempleData-container">
          <h4>ISIS Web Developers</h4>
          <h4>
            Project By <span>ISIS FDA</span>
          </h4>
        </div>
      </div>

      {/* <!-- End Footer --> */}
    </>
  );
}
